module.exports = __webpack_public_path__ + "img/noDevice.9d1ee9ee.png";